import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/falcon-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-falcon-colorado",
      statusCode: 301,
    });
  },
});
